import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type { Resolvable } from '@/services/resolvers/types'
import type ByocService from '@/services/domain/byoc/byocService'
import type { IMainServerSub, TServerEvent } from '@/services/transport/serverEvents'
import type PermissionsService from '@/services/permissionsService'

@injectable()
export default class ByocAccessResolver implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.ByocService) protected readonly byocService: ByocService,
    @inject(SERVICE_TYPES.ServerSubscriptionService)
    private readonly serverSubscriptionService: IMainServerSub,
    @inject(SERVICE_TYPES.PermissionsService) private readonly permissionsService: PermissionsService,
  ) {}

  public async resolve() {
    this.serverSubscriptionService.subscribe(
      'systemAccountPermissionsChanged',
      this.systemAccountPermissionsChangedEventHandler,
    )
  }

  public async unresolve() {
    this.serverSubscriptionService.unsubscribe(
      'systemAccountPermissionsChanged',
      this.systemAccountPermissionsChangedEventHandler,
    )
  }

  private systemAccountPermissionsChangedEventHandler = (e: TServerEvent<'systemAccountPermissionsChanged'>) => {
    const { manageCpaasProviders } = e.payload.channelsPermissions
    const { byoc } = e.payload.messagingPermissions
    const isManageGranted =
      manageCpaasProviders.value &&
      this.permissionsService.isActivePermission('manageCpaasProviders') !== manageCpaasProviders.value
    const isSendingChanged = this.permissionsService.isActivePermission('byoc') !== byoc.value
    if (!isManageGranted && !isSendingChanged) {
      return
    }
    this.byocService.refreshSettings()
  }
}
